import epics from './signInPage.epics';
import reducers from './signInPage.reducers';

export {
  epics,
  reducers,
};

export default 'signInPage';
